import { useMutation } from "@tanstack/react-query";
import estimateProvider from "@/providers/estimate.provider";
import type { PricingAndDimensionInfo } from "@rebuild/shared";

const GENERATE_PDF_PREVIEW_KEY = ["pdfExport", "generatePreview"] as const;

export function useGeneratePDFPreviewMutation() {
  return useMutation({
    mutationKey: GENERATE_PDF_PREVIEW_KEY,
    mutationFn: async (params: {
      estimateId: string;
      pricingAndDimensionInfo: PricingAndDimensionInfo;
      verbose: boolean;
      clearCache?: boolean;
    }) => {
      const response = await estimateProvider.getPDFPreviewData(
        params.estimateId,
        params.pricingAndDimensionInfo,
        params.verbose,
        params.clearCache ?? false,
      );
      if (!response.success || !response.data) {
        throw new Error(response.error ?? "Failed to generate PDF preview");
      }
      return response.data;
    },
  });
}
